"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _elementUi = require("element-ui");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));
var _vue = _interopRequireDefault(require("vue"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // progress bar
// progress bar style
// get token from cookie
// 添加这行

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/auth-redirect', '/wxWorkLoginCallBack']; // no redirect whitelist
_router.default.beforeEach(/*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasRoles, res, data, orgGroup, accessRoutes, _t;
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          _nprogress.default.start();
          // set page title
          document.title = (0, _getPageTitle.default)(to.meta.title);
          console.log("from", from);
          console.log("to", to);
          if (to.query && to.query.token) {
            (0, _auth.setToken)(to.query.token);
          }
          // determine whether the user has logged in（优先 Vuex，兜底 cookie，避免跨站 iframe cookie 被浏览器阻止）
          hasToken = _store.default.getters.token || (0, _auth.getToken)();
          if (!hasToken) {
            _context.next = 8;
            break;
          }
          if (!(to.path === '/login')) {
            _context.next = 1;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          _nprogress.default.done();
          _context.next = 7;
          break;
        case 1:
          hasRoles = _store.default.getters.roles && _store.default.getters.roles.length > 0;
          if (!hasRoles) {
            _context.next = 2;
            break;
          }
          next();
          _context.next = 7;
          break;
        case 2:
          _context.prev = 2;
          _context.next = 3;
          return _store.default.dispatch('user/getUserInfo');
        case 3:
          res = _context.sent;
          data = res.data.list;
          orgGroup = res.data.orgGroup;
          _context.next = 4;
          return _store.default.dispatch('permission/generateRoutes', {
            data: data,
            orgGroup: orgGroup
          });
        case 4:
          accessRoutes = _context.sent;
          _router.default.addRoutes(accessRoutes);
          if (from.path === '/login') {
            next({
              path: "/"
            });
          } else {
            next(_objectSpread(_objectSpread({}, to), {}, {
              replace: true
            }));
          }
          _context.next = 7;
          break;
        case 5:
          _context.prev = 5;
          _t = _context["catch"](2);
          _context.next = 6;
          return _store.default.dispatch('user/resetToken');
        case 6:
          _elementUi.Message.error(_t || 'Has Error');
          next("/login?redirect=".concat(to.path));
          _nprogress.default.done();
        case 7:
          _context.next = 9;
          break;
        case 8:
          /* has no token*/
          if (whiteList.indexOf(to.path) !== -1) {
            next();
          } else {
            next("/login?redirect=".concat(to.path));
            _nprogress.default.done();
          }
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 5]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});

// 组件自动化全局注册
var requireComponent = require.context(
// 其组件目录的相对路径
'./views/zdy_dragging/component',
// 是否查询其子目录
true,
// 匹配基础组件文件名的正则表达式
/\.vue$/);
requireComponent.keys().forEach(function (fileName) {
  // 获取组件配置
  var componentConfig = requireComponent(fileName);
  // 全局注册组件
  _vue.default.component(componentConfig.default.name,
  // 此处的name,是组件属性定义的name
  // 如果这个组件选项是通过 `export default` 导出的，
  // 那么就会优先使用 `.default`，
  // 否则回退到使用模块的根。
  componentConfig.default);
});